import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { SmsService } from "../../../../../../services/sms/sms.service";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { SmsCsvDTO } from "../../../../../../utils/types/sms/smsCsvDTO.type";
import { SharedCatalogService } from "../../../../../../services/shared/sharedcatalog.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-sms-form-csv",
    templateUrl: "./sms-form-csv.component.html",
    styleUrls: ["./sms-form-csv.component.scss"],
    providers: [SmsService, AuthenticationService, SharedCatalogService],
    encapsulation: ViewEncapsulation.None,
})
export class SmsFormCSVComponent implements OnInit {
    smsCsvModel: SmsCsvDTO;
    dialogTitle: string;
    smsCsvForm: FormGroup;
    action: RecordAction;
    hideMessage: boolean = false;
    fileToUpload: any;
    fileDescription: FormControl;
    delimitadores: any;
    shortCodes: any;

    groups: any;
    widget6: any = {};
    results: any;
    view: any[] = [450, 200];
    processing = false;
    finished = false;
    companyId: Number;
    hasURL: boolean;

    callback: (sms) => void;

    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<SmsFormCSVComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: SmsService,
        private sharedCatalog: SharedCatalogService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.companyId = data.companyId;
        this.action = data.action;
        this.operators = data.operators;
        this.callback = data.callback;

        this.delimitadores = sharedCatalog.getDelimiters();
        this.dialogTitle = "Lanzar Campaña por CSV";
        this.dialogTitle = this.translateService.instant(this.dialogTitle);
        this.smsCsvModel = new SmsCsvDTO();

        this.smsCsvForm = this.createForm();
        if (this.action === this.recordAction.View) {
            this.smsCsvForm.controls["delimiter"].disable();
            this.smsCsvForm.controls["shortcode"].disable();
        }

        this.widget6 = {
            label: "Registros Procesados",
            scheme: {
                domain: ["#03a9f4", "#f44336", "#db951c", "#9c27b0"],
            },
        };

        this.widget6.label = this.translateService.instant(this.widget6.label);
    }

    ngOnInit() {
        this.sharedCatalog
            .getShortcodesObjects(this.companyId)
            .subscribe((res) => {
                this.shortCodes = res;
            });
    }

    onChangeHideMessage(event) {
        this.hideMessage = event.checked;
    }

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.smsCsvModel.name, [Validators.required]),
            delimiter: new FormControl(this.smsCsvModel.delimeter, [
                Validators.required,
            ]),
            shortcode: new FormControl(this.smsCsvModel.IdShortCode, [
                Validators.required,
            ]),
            fileInput: new FormControl("", [Validators.required]),
            serviceType: new FormControl(this.smsCsvModel.serviceType),
            longUrl: new FormControl(this.smsCsvModel.longUrl),
            validityPeriod: new FormControl(this.smsCsvModel.validityPeriod),
            //    isActive: new FormControl( Boolean(this.smsModel.status)),
            //    operadora: new FormControl(this.smsModel.operatorId, [Validators.required])
        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.smsCsvModel.name = value)
        );
        form.controls["delimiter"].valueChanges.subscribe(
            (value) => (this.smsCsvModel.delimeter = value)
        );
        form.controls["shortcode"].valueChanges.subscribe(
            (value) => (this.smsCsvModel.IdShortCode = value)
        );
        form.controls["longUrl"].valueChanges.subscribe(
            (value) => (this.smsCsvModel.longUrl = value)
        );
        form.controls["validityPeriod"].valueChanges.subscribe(
            (value) => (this.smsCsvModel.validityPeriod = value)
        );

        form.controls["serviceType"].valueChanges.subscribe((value) => {
            if (value !== null && value !== "") {
                this.smsCsvModel.serviceType = value;
            } else {
                this.smsCsvModel.serviceType = "0";
            }
        });
        //   form.controls['isActive'].valueChanges.subscribe((value) => this.smsModel.status = Number(value));
        //   form.controls['operadora'].valueChanges.subscribe((value) => this.smsModel.operatorId = value);

        return form;
    }

    performAction() {
        if (this.smsCsvForm.invalid) {
            return;
        }
        this.smsCsvModel.file = this.fileToUpload;
        this.smsCsvModel.obfuscated = this.hideMessage;

        this.performAddSmsCsv(this.smsCsvModel);
    }

    hasUrl(event) {
        if (event.checked) {
            this.hasURL = true;
            this.smsCsvForm.controls["longUrl"].setValidators([
                Validators.required,
            ]);
        } else {
            this.hasURL = false;
            this.smsCsvForm.controls["longUrl"].clearValidators();
            this.smsCsvForm.controls["longUrl"].updateValueAndValidity();
        }
    }

    performAddSmsCsv(data: SmsCsvDTO) {
        this.service.uploadCSV(data).subscribe((result) => {
            this.results = [
                {
                    name: "Exitosos",
                    value: result.success,
                },
                {
                    name: "Con Error",
                    value: result.errorFormat,
                },
                {
                    name: "Duplicados",
                    value: result.duplicated,
                },
            ];

            this.results.forEach((element) => {
                element.name = this.translateService.instant(element.name);
            });

            this.processing = false;
            this.finished = true;
        });
    }

    handleFileInput(files: FileList) {
        const fileItem = files.item(0);
        this.fileToUpload = fileItem;
        this.smsCsvForm.controls["fileInput"].setValue(
            fileItem ? fileItem.name : ""
        );
        document.querySelector(".file-name").textContent = fileItem.name;
    }

    close() {
        this.callback(this.smsCsvModel);
    }
}
